export const CAMPAIGN_FLOW_STEPS = [
  { id: "leads", label: "List Of Leads", path: "" },
  { id: "senders", label: "LinkedIn Senders", path: "senders" },
  { id: "sequence", label: "Sequence", path: "sequence" },
  { id: "schedule", label: "Schedule", path: "schedule" },
  { id: "launch", label: "Review & Launch", path: "review-launch" },
] as const;

export const DEFAULT_CAMPAIGN_NAME = "";

export type CampaignTimezoneOption = { value: string; label: string };

export const CAMPAIGN_TIMEZONE_OPTIONS: CampaignTimezoneOption[] = [
  { value: "Etc/GMT+12", label: "Baker Island (UTC-12 / GMT-12)" },
  { value: "Pacific/Pago_Pago", label: "American Samoa, Midway Atoll (SST, UTC-11 / GMT-11)" },
  { value: "Pacific/Honolulu", label: "Honolulu (HST, UTC-10 / GMT-10)" },
  { value: "America/Anchorage", label: "Anchorage (AKST/AKDT, UTC-9 / GMT-9)" },
  { value: "America/Los_Angeles", label: "Los Angeles (PST/PDT, UTC-8 / UTC-7)" },
  { value: "America/Denver", label: "Denver (MST/MDT, UTC-7 / UTC-6)" },
  { value: "America/Mexico_City", label: "Mexico City (CST/CDT, UTC-6 / UTC-5)" },
  { value: "America/New_York", label: "New York (EST/EDT, UTC-5 / UTC-4)" },
  { value: "America/Santiago", label: "Caracas, Santiago (UTC-4 / GMT-4)" },
  { value: "America/Argentina/Buenos_Aires", label: "Buenos Aires, Sao Paulo (UTC-3 / GMT-3)" },
  { value: "Atlantic/South_Georgia", label: "South Georgia (UTC-2 / GMT-2)" },
  { value: "Atlantic/Azores", label: "Azores, Cape Verde (UTC-1 / GMT-1)" },
  { value: "Europe/London", label: "London (GMT/BST, UTC+0 / UTC+1)" },
  { value: "Europe/Paris", label: "Paris, Berlin (CET/CEST, UTC+1 / UTC+2)" },
  { value: "Europe/Athens", label: "Cairo, Athens (EET/EEST, UTC+2 / UTC+3)" },
  { value: "Europe/Moscow", label: "Moscow, Riyadh (MSK, UTC+3 / GMT+3)" },
  { value: "Asia/Dubai", label: "Dubai, Baku (GST, UTC+4 / GMT+4)" },
  { value: "Asia/Karachi", label: "Islamabad (PKT, UTC+5 / GMT+5)" },
  { value: "Asia/Dhaka", label: "Dhaka (BST, UTC+6 / GMT+6)" },
  { value: "Asia/Bangkok", label: "Bangkok, Jakarta (ICT, UTC+7 / GMT+7)" },
  { value: "Asia/Singapore", label: "Beijing, Singapore (SGT/CST, UTC+8 / GMT+8)" },
  { value: "Asia/Tokyo", label: "Tokyo, Seoul (JST/KST, UTC+9 / GMT+9)" },
  { value: "Australia/Sydney", label: "Sydney (AEST/AEDT, UTC+10 / UTC+11)" },
  { value: "Pacific/Guadalcanal", label: "Solomon Islands (UTC+11 / GMT+11)" },
  { value: "Pacific/Auckland", label: "Auckland (NZST/NZDT, UTC+12 / UTC+13)" },
];

export const resolveCampaignTimezoneLabel = (timezoneValue?: string | null) => {
  const normalized = String(timezoneValue || "").trim();
  if (!normalized) return "—";
  return (
    CAMPAIGN_TIMEZONE_OPTIONS.find((option) => option.value === normalized)?.label ||
    normalized
  );
};
